// extracted by mini-css-extract-plugin
export default {"confirmCancelApplicationModal":"mT1y4YDNy7KAxr4WJ4A7","descriptionModal":"xp6DKx9olHBiNENx7kRa"};